import { Bar, mixins } from 'vue-chartjs';
import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.plugins.unregister(ChartDataLabels);

const { reactiveProp } = mixins;

export default {
  extends: Bar,
  mixins: [reactiveProp],
  props: {
    options: {
      type: Object,
      default: null,
    },
    showDataLabels: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if (this.showDataLabels) {
      this.addPlugin(ChartDataLabels);
    }

    this.renderChart(this.chartData, this.options);
  },
};
